import { useMutation, useQueryClient } from '@tanstack/react-query'

import { brandsApi } from '@/api/brands/brandsApi'
import { brandsQueries } from '@/api/brands/brandsQueries'

export const useCreateBrandAliasMutation = (brandId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (alias: string) => brandsApi.createAlias(brandId, alias),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: brandsQueries.aliases(brandId).queryKey,
      })
    },
  })
}
